import { useAppSelector } from "../hooks";

export const useGetFaqCategories = () => {
  const { data, status } = useAppSelector(({ faqs }) => faqs.faqCategories);

  return {
    data,
    status,
  };
};

export const useGetFaqsByCategoryId = () => {
  const { data, status } = useAppSelector(({ faqs }) => faqs.faqsByCategoryId);

  return {
    data,
    status,
  };
};

export const useCreateFaqEngagement = () => {
  const { status } = useAppSelector(({ faqs }) => faqs.createFaqEngagement);

  return {
    status,
  };
};
